import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  VERIFY_OTP_REQUEST,
  LOGOUT,
  CLEAR_ERROR,
  UPDATE_STUDENT_ID,
  UPDATE_TUTOR_ID,
  UPDATE_INSTITUTION_ID,
} from "../constants";

export const loginRequest = (formData) => ({
  type: LOGIN_REQUEST,
  payload: formData,
});

export const verifyOtpRequest = (formData) => ({
  type: VERIFY_OTP_REQUEST,
  payload: formData,
});

export const loginSuccess = (response) => ({
  type: LOGIN_SUCCESS,
  payload: response,
});

export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error,
});

export const logout = () => ({
  type: LOGOUT,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const updateStudentId = (studentId) => ({
  type: UPDATE_STUDENT_ID,
  payload: studentId,
});

export const updateTutorId = (tutorId) => ({
  type: UPDATE_TUTOR_ID,
  payload: tutorId,
});

export const updateInstitutionId = (institutionId) => ({
  type: UPDATE_INSTITUTION_ID,
  payload: institutionId,
});


